var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2221_326098",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2221_326098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10.042C10.472 10.042 10.8747 9.87533 11.208 9.54199C11.5413 9.20866 11.708 8.80566 11.708 8.33299C11.708 7.86099 11.5413 7.45833 11.208 7.12499C10.8747 6.79166 10.472 6.62499 10 6.62499C9.52801 6.62499 9.12534 6.79166 8.79201 7.12499C8.45867 7.45833 8.29201 7.86099 8.29201 8.33299C8.29201 8.80566 8.45867 9.20866 8.79201 9.54199C9.12534 9.87533 9.52801 10.042 10 10.042ZM10 16C11.6807 14.4587 12.9203 13.0663 13.719 11.823C14.5177 10.5797 14.917 9.47199 14.917 8.49999C14.917 6.98599 14.4447 5.76033 13.5 4.82299C12.5553 3.88566 11.3887 3.41699 10 3.41699C8.61134 3.41699 7.44467 3.88566 6.50001 4.82299C5.55534 5.76033 5.08301 6.98599 5.08301 8.49999C5.08301 9.47199 5.48234 10.5797 6.28101 11.823C7.07967 13.0663 8.31934 14.4587 10 16ZM10 18.333C7.76401 16.403 6.09401 14.6323 4.99001 13.021C3.88534 11.4097 3.33301 9.90266 3.33301 8.49999C3.33301 6.40266 3.99967 4.73933 5.33301 3.50999C6.66634 2.28133 8.22201 1.66699 10 1.66699C11.778 1.66699 13.3337 2.28133 14.667 3.50999C16.0003 4.73933 16.667 6.40266 16.667 8.49999C16.667 9.90266 16.1147 11.4097 15.01 13.021C13.906 14.6323 12.236 16.403 10 18.333Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.31969ed8ff4d94c17ff6be28084330e3.svg";
export { ForwardRef as ReactComponent };